export default {
  // 搜索框
  searchPlaceholder: "搜索币种简称或代币合约地址",

  // 合约信息提示
  notFoundData: "未找到符合搜索内容的数据 请修正后重试",

  // 币种选项
  all: "全部",
  commonCurrencies: "常用币种",
  contractTokens: "合约代币",

  // 成功消息
  currencyModifiedSuccess: "币种修改成功",
};
